module.exports = __webpack_public_path__ + "static/9f20a9cc34fed326317641739606afa34eb2d57498cdbc2155e9ae6cd4656f7c-cd0aa92341ed41ac0d11c98fdcbad3d3.jpeg";